export default __webpack_public_path__ + "static/media/deliveryOnly_active.2b07d4e9.svg";